import { useMemo } from 'react';
import {
 AUTOSAVE_STATUS
} from "@demandproai/shared";
import {
  autosaveBadgeClasses,
  autosaveStatusToClasses,
} from '../components/lifecare-studio/lifecareStudioClasses';

const STATUS_TO_LABEL = {
  [AUTOSAVE_STATUS.IDLE]: 'Up to date',
  [AUTOSAVE_STATUS.SAVING]: 'Saving...',
  [AUTOSAVE_STATUS.SAVED]: 'Saved',
  [AUTOSAVE_STATUS.FAILED]: 'Save failed',
};

const STATUS_TO_ICON = {
  [AUTOSAVE_STATUS.IDLE]: 'fa fa-check',
  [AUTOSAVE_STATUS.SAVING]: 'fa fa-spinner animate-spin',
  [AUTOSAVE_STATUS.SAVED]: 'fa fa-check',
  [AUTOSAVE_STATUS.FAILED]: 'fa fa-exclamation-circle',
};

// derives the presentational pieces for the autosave badge from a raw status,
// so the badge component stays dumb (markup-only)
const useLifecareStudioAutosaveBadge = ({ status }) => {
  return useMemo(() => {
    const resolvedStatus = status || AUTOSAVE_STATUS.IDLE;
    const variantClasses = autosaveStatusToClasses[resolvedStatus] || autosaveStatusToClasses.idle;
    return {
      badgeClassName: `${autosaveBadgeClasses} ${variantClasses}`,
      iconClassName: STATUS_TO_ICON[resolvedStatus],
      label: STATUS_TO_LABEL[resolvedStatus],
    };
  }, [status]);
};

export default useLifecareStudioAutosaveBadge;
